import Box from '~/core/Box'

type ShipToPropsType = {
    postalAddress?: {
        name: string | null
        street: string | null
        street2: string | null
        city: string | null
        stateName?: string | null
        state?: string | null
        zip?: string | null
        postalCode?: string | null
    } | null
}

export default function ShipTo(props: ShipToPropsType) {
    const { postalAddress = null } = props

    return (
        <Box direction="col">
            <Box data-test-target="order-details-shipping-address-name">
                {postalAddress?.name}
            </Box>
            <Box data-test-target="order-details-shipping-address-street">
                {postalAddress?.street}
            </Box>
            {postalAddress?.street2 && <Box>{postalAddress?.street2}</Box>}
            <Box data-test-target="order-details-shipping-address-city">
                {' '}
                {`${postalAddress?.city ? `${postalAddress?.city}, ` : ''}${
                    postalAddress?.stateName || postalAddress?.state
                        ? `${postalAddress?.stateName || postalAddress?.state} `
                        : ''
                } ${postalAddress?.zip || postalAddress?.postalCode}`}
            </Box>
        </Box>
    )
}
